/**
 * Countdown days, hours, minutes and seconds
 * @module addToCalendar
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'addToCalendar';
export const DEFAULTS = {
  icsServices: ['iCal', 'Outlook'],
};

const formatTime = (date) => {
  const newDate = new Date(date);
  return newDate.toISOString().replace(/-|:|\.\d+/g, '');
};

const calculateEndTime = (startTime, endTime, opts) => {
  const { duration } = opts;
  const MS_IN_MINUTES = 60 * 1000;
  return endTime ?
    formatTime(endTime) :
    formatTime(new Date(startTime.getTime() + (duration * MS_IN_MINUTES)));
};

const googleGenerator = (startTime, endTime, opts) => {
  const { title, description, address } = opts;
  const formatedStartTime = formatTime(startTime);
  const calEndTime = calculateEndTime(startTime, endTime, opts);
  const href = encodeURI(`https://www.google.com/calendar/render?action=TEMPLATE&text=${title || ''}&dates=${formatedStartTime || ''}/${calEndTime || ''}&details=${description || ''}&location=${address || ''}&sprop=&sprop=name:`);

  return `<a class="action-button action-button--md action-button--full" target="_blank" href="${href}">Google Calendar</a>`;
};

const yahooGenerator = (startTime, endTime, opts) => {
  const { title, description, address, duration } = opts;
  const formatedStartTime = formatTime(opts.start);
  const MS_IN_MINUTES = 60 * 1000;
  const eventDuration = endTime ?
    ((endTime.getTime() - startTime.getTime()) / MS_IN_MINUTES) :
    duration;

  // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
  const hourDuration = eventDuration < 600 ?
        `0${Math.floor((eventDuration / 60))}` : `${Math.floor((eventDuration / 60))}`;
  const minuteDuration = eventDuration % 60 < 10 ?
        `0${eventDuration % 60}` : `${eventDuration % 60}`;
  const formatedEventDuration = `${hourDuration}${minuteDuration}`;
  const href = encodeURI(`http://calendar.yahoo.com/?v=60&view=d&type=20&title=${title || ''}&st=${formatedStartTime}&dur=${formatedEventDuration || ''}&desc=${description || ''}&in_loc=${address || ''}`);

  return `<a class="action-button action-button--md action-button--full" target="_blank" href="${href}">Yahoo! Calendar</a>`;
};

const icsGenerator = (startTime, endTime, opts) => {
  const {
    icsServices,
    url,
    title,
    description,
    address,
  } = opts;
  const formatedStartTime = formatTime(startTime);
  const calcEndTime = calculateEndTime(startTime, endTime, opts);

  const icsButtons = icsServices.map((calendarName) => {
    /* eslint-disable prefer-template */
    const href = encodeURI(
        'data:text/calendar;charset=utf8,' + [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'BEGIN:VEVENT',
          'URL:' + url,
          'DTSTART:' + (formatedStartTime || ''),
          'DTEND:' + (calcEndTime || ''),
          'SUMMARY:' + (title || ''),
          'DESCRIPTION:' + (description || ''),
          'LOCATION:' + (address || ''),
          'END:VEVENT',
          'END:VCALENDAR'].join('\n'));
    return `<a class="action-button action-button--md action-button--full" target="_blank"
    href="${href}">${calendarName} Calendar</a>`;
  });
  return icsButtons;
};

const generateMarkup = ($el, startTime, endTime, opts) => {
  const googleBtn = googleGenerator(startTime, endTime, opts);
  const yahooBtn = yahooGenerator(startTime, endTime, opts);
  const otherServicesBtn = icsGenerator(startTime, endTime, opts);

  $el.append(googleBtn, yahooBtn, otherServicesBtn);
};

/**
 * Initializes addToCalendar
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function addToCalendar(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  const { start, end } = opts;
  const startTime = new Date(start);
  const endTime = new Date(end);
  generateMarkup($el, startTime, endTime, opts);
}
registerJQueryPlugin(PLUGIN_NAME, addToCalendar);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/add-to-calendar.js